<template>
  <footer class="foot-wrap">
    <div class="foot-link">
      <div class="container-wrap">
        <nav>
          <div class="font-20 font-bold">导航</div>
          <ul class="nav-link-list text-left margin-top-20">
            <!--<router-link to="/home" tag="li"><h1 style="line-height: inherit; margin:0; font-size: inherit"><img-->
            <!--class="inline-block img-logo" :src="logo" alt="好尔美logo" title="好尔美logo"></h1></router-link>-->
            <!--<router-link to="/home" tag="li">首页 ></router-link>-->
            <router-link to="/old-care" tag="li">智慧养老 ></router-link>
            <router-link to="/news-list" tag="li">健康资讯 ></router-link>

            <router-link to="/join-us" tag="li">招商加盟 ></router-link>
            <li>
              <a class="nav-mall" :href="mallUrl" style="color:#332c2b">好尔美商城 ></a>
            </li>
            <!--<router-link to="/health-mall" tag="li">健康商城</router-link>-->
            <router-link to="/about-us-list" tag="li">关于我们 ></router-link>
          </ul>
        </nav>
        <!-- <div class="margin-top-40">
          <div class="font-20 font-bold">APP下载</div>
          <div class="margin-top-20">
            <div class="qr-code-wrap">
              <img :src="serviceQrCode" class="qr-img" alt=""><br>
              <span class="inline-block margin-top-10">IOS用户端</span>
            </div>
            <div class="qr-code-wrap">
              <img :src="subscribeQrCode" class="qr-img" alt=""><br>
              <span class="inline-block margin-top-10">IOS服务端</span>
            </div>
            <div class="qr-code-wrap">
              <img :src="oldQrCode" class="qr-img" alt=""><br>
              <span class="inline-block margin-top-10">Android用户端</span>
            </div>
            <div class="qr-code-wrap">
              <img :src="staffQrCode" class="qr-img" alt=""><br>
              <span class="inline-block margin-top-10">Android服务端</span>
            </div>
          </div>

        </div>-->

        <div class="margin-top-40">
          <div class="font-20 font-bold">友情链接</div>
          <ul class="friendly-link">
            <li class="link-li">
              <a href="https://news.fh21.com.cn/" rel="nofollow" target="_blank">飞华健康网</a>
            </li>
            <li class="link-li">
              <a href="http://www.qm120.com/" rel="nofollow" target="_blank">全民健康网</a>
            </li>
            <li class="link-li">
              <a href="https://www.99.com.cn/" rel="nofollow" target="_blank">99健康网</a>
            </li>
            <li class="link-li">
              <a href="https://www.chemdrug.com/" rel="nofollow" target="_blank">药品资讯网</a>
            </li>
            <li class="link-li">
              <a href="https://www.zhzyw.com/" rel="nofollow" target="_blank">中医中药网</a>
            </li>
            <li class="link-li">
              <a href="http://www.iqiyi.com/health/" rel="nofollow" target="_blank">爱奇艺健康</a>
            </li>
            <li class="link-li">
              <a href="http://jiankang.163.com/" rel="nofollow" target="_blank">网易健康</a>
            </li>
            <li class="link-li">
              <a href="http://health.qq.com/" rel="nofollow" target="_blank">腾讯健康</a>
            </li>
            <li class="link-li">
              <a href="http://www.familydoctor.com.cn/" rel="nofollow" target="_blank">家庭医生在线</a>
            </li>
            <li class="link-li">
              <a href="http://health.huanqiu.com/?agt=383" rel="nofollow" target="_blank">生命时报</a>
            </li>
            <li class="link-li">
              <a href="https://yyk.91985.com/?agt=383" rel="nofollow" target="_blank">助医网</a>
            </li>
            <li class="link-li">
              <a href="http://www.zol.com.cn/" rel="nofollow" target="_blank">中关村在线</a>
            </li>
            <li class="link-li">
              <a href="http://www.imobile.com.cn/" rel="nofollow" target="_blank">手机之家</a>
            </li>
            <li class="link-li">
              <a href="http://www.wenkang.cn/" rel="nofollow" target="_blank">闻康网</a>
            </li>
            <li class="link-li">
              <a href="https://www.haodf.com/" rel="nofollow" target="_blank">好大夫在线</a>
            </li>
            <li class="link-li">
              <a href="https://www.jiankang.com/" rel="nofollow" target="_blank">百姓健康网</a>
            </li>
            <li class="link-li">
              <a href="https://www.cn-healthcare.com/" rel="nofollow" target="_blank">健康界</a>
            </li>
            <li class="link-li">
              <a href="http://www.myzx.cn/web/index" rel="nofollow" target="_blank">名医在线</a>
            </li>
            <li class="link-li">
              <a href="http://www.hxyjw.com/" rel="nofollow" target="_blank">华夏医界网</a>
            </li>
            <li class="link-li">
              <a href="http://www.julijia.cn/" rel="nofollow" target="_blank">居利家</a>
            </li>
            <li class="link-li">
              <a href="http://www.ynb91.com/" rel="nofollow" target="_blank">中医</a>
            </li>
            <li class="link-li">
              <a href="http://www.yanglaocn.com/" rel="nofollow" target="_blank">养老信息网</a>
            </li>
            <li class="link-li">
              <a href="http://www.cnsf99.com/" rel="nofollow" target="_blank">中国养老网</a>
            </li>
            <li class="link-li">
              <a href="http://www.cncahl.com/" rel="nofollow" target="_blank">中国智能养老网</a>
            </li>
            <li class="link-li">
              <a href="http://www.longang123.com/" rel="nofollow" target="_blank">生活娱乐网</a>
            </li>
            <li class="link-li">
              <a href="http://health.sina.com.cn/" rel="nofollow" target="_blank">新浪健康</a>
            </li>
            <li class="link-li">
              <a href="http://www.laoren.com/" rel="nofollow" target="_blank">老人网</a>
            </li>
            <li class="link-li">
              <a href="https://www.pingguolv.com/" rel="nofollow" target="_blank">苹果绿养生网</a>
            </li>
            <li class="link-li">
              <a href="http://www.cnkang.com/" rel="nofollow" target="_blank">中华康网</a>
            </li>
            <li class="link-li">
              <a href="http://www.fx120.net/" rel="nofollow" target="_blank">放心医苑网</a>
            </li>
          </ul>
        </div>
        <!--<div class="clearfix">-->
        <!--<div class="pull-left clearfix  link-wrap">-->
        <!--<ul class="pull-left">-->
        <!--<router-link class="font-20" to="/about-us-list" tag="li"><strong>关于我们</strong></router-link>-->
        <!--<router-link to="/about-us-list/company-info" tag="li">公司简介</router-link>-->
        <!--<router-link to="/about-us-list/contact-us" tag="li">联系我们</router-link>-->
        <!--<router-link to="/about-us-list/strategic-cooperation" tag="li">战略合作</router-link>-->
        <!--</ul>-->
        <!--<ul class="pull-right border-right border-padding">-->
        <!--<router-link class="font-20" to="/news-list" tag="li"><strong>健康资讯</strong></router-link>-->
        <!--<router-link tag="li" v-for="(item,index) in subTitle" :key="index" to="/"  v-show="index<=2" @click.native="goTo(item.dirName,index,item.id)">-->
        <!--<span>{{item.dirName}}</span>-->
        <!--</router-link>-->
        <!--</ul>-->
        <!--</div>-->
        <!--<div class="pull-right">-->
        <!--<div class="qr-code-wrap">-->
        <!--<img :src="serviceQrCode" class="qr-img" alt=""><br>-->
        <!--<span class="inline-block margin-top-10">IOS用户端</span>-->
        <!--</div>-->
        <!--<div class="qr-code-wrap">-->
        <!--<img :src="subscribeQrCode" class="qr-img" alt=""><br>-->
        <!--<span class="inline-block margin-top-10">IOS服务端</span>-->
        <!--</div>-->
        <!--<div class="qr-code-wrap">-->
        <!--<img :src="oldQrCode" class="qr-img" alt=""><br>-->
        <!--<span class="inline-block margin-top-10">Android用户端</span>-->
        <!--</div>-->
        <!--<div class="qr-code-wrap">-->
        <!--<img :src="staffQrCode" class="qr-img" alt=""><br>-->
        <!--<span class="inline-block margin-top-10">Android服务端</span>-->
        <!--</div>-->
        <!--</div>-->

        <!--</div>-->
      </div>
    </div>
    <div class="foot-copyright">
      <div class="container-wrap">
        <div class="inline-block margin-right-20">
          <!--<a href="https://qy.pinpaibao.com.cn/certificate?domain=www.yschsz.com&from=label"><img src="https://aqyzmedia.yunaq.com/labels/label_lg_90040.png"></a>-->
          <a
            rel="nofollow"
            href="https://v.yunaq.com/certificate?domain=www.yschsz.com&code=90040"
            target="_blank"
          >
            <img src="https://aqyzmedia.yunaq.com/labels/label_sm_90040.png" />
          </a>
        </div>
        <div class="clearfix margin-top-20">
          <div class="pull-left margin-top-20 margin-right-20">
            <!-- <span class="margin-right-20">Copyrights 2020 yschsz.com, All Rights Reserved</span> -->
               <span class="margin-right-20">
              <a
                target="_blank"
                style="color:#332c2b"
                href="http://beian.miit.gov.cn"
              >粤ICP备18067700号</a>
            </span>
            <span class="margin-right-20">ICP许可证：粤B2-20200945</span>
            <span>
              <img :src="pub" alt="公安" /> 公安联网备案号：44030602004228
            </span>
          </div>
          <div class="pull-left margin-top-20 margin-right-20">
            <span class="margin-right-20">Copyrights 2020 yschsz.com, All Rights Reserved</span>
            <span class="margin-right-20">
              <router-link class to="/map-site">网站地图</router-link>
              <a
                rel="nofollow"
                class="statistic cursor-pointer"
                target="_blank"
                href="https://tongji.baidu.com/web/welcome/login"
              >百度统计</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mallUrl } from "@/assets/js/util.js";
export default {
  name: "Footer",
  data() {
    return {
      mallUrl: mallUrl,
      logo: require("@/assets/img/logo.png"),
      staffQrCode: require("@/assets/img/home/staff-qr-code.png"),
      oldQrCode: require("@/assets/img/home/old-qr-code.png"),
      serviceQrCode: require("@/assets/img/home/old-ios.png"),
      subscribeQrCode: require("@/assets/img/home/staff-ios.png"),
      pub: require("@/assets/img/home/public.png"),
      subTitle: []
    };
  },
  mounted() {
    this.titleInit();
  },
  methods: {
    //栏目标题初始化
    titleInit() {
      this.axios.get("/ajax/admin/user/information/catalog").then(res => {
        if (res.data.respStatus == 1) {
          if (res.data.respBody || res.data.respBody.length) {
            this.subTitle = res.data.respBody[0].topicDirectorys;
          }
        }
      });
    },
    goTo(name, index, id) {
      this.$router.push({
        path: "/news-list",
        query: { name: name, index: index, id: id }
      });
    }
  }
};
</script>

<style scoped>
.font-bold {
  font-weight: bold;
}
.statistic {
  margin-left: 20px;
}

.foot-wrap {
  /*color: #fff;*/
  margin-top: 70px;
}

.foot-wrap ul li {
  cursor: pointer;
  /*margin-top: 30px;*/
}

.foot-link {
  background: #eeeeef;
  padding-top: 34px;
  padding-bottom: 40px;
}

.foot-copyright {
  /*background: #474443;*/
  padding-top: 40px;
  padding-bottom: 40px;
}

.qr-code-wrap {
  display: inline-block;
  /*margin-left: 50px;*/
  width: 20%;
  padding-top: 10px;
  font-size: 0.14rem;
  text-align: center;
}

.qr-img {
  width: 130px;
  height: auto;
}

.nav-mall:link,
.nav-mall:visited,
.nav-mall:hover,
.nav-mall:active {
  color: #332c2b;
}

.nav-link-list {
  font-size: 0.16rem;
}

.nav-link-list li {
  display: inline-block;
  cursor: pointer;
  padding-left: 60px;
  padding-right: 60px;
  line-height: 18px;
  border-left: 1px solid;
}

.nav-link-list li:first-child {
  border: none;
  padding-left: 50px;
}
.friendly-link {
  padding-left: 50px;
  margin-top: 20px;
}

.friendly-link .link-li {
  display: inline-block;
  width: 9%;
  padding-bottom: 10px;
  font-size: 0.14rem;
}
.friendly-link .link-li a {
  color: inherit;
}

.header-margin {
  margin-left: 100px;
}
.img-logo {
  width: 100px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue